"use client";
import { jsxs as r, jsx as C } from "react/jsx-runtime";
import { memo as n, forwardRef as i } from "react";
import { useSvgIcon as t } from "../useSvgIcon.js";
const c = n(
  i((o, l) => {
    const e = t({
      ...o,
      ref: l
    });
    return /* @__PURE__ */ r(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e(),
        children: [
          /* @__PURE__ */ C(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.84702 16.0204C8.84702 19.9738 12.0464 23.1936 16.0202 23.1936C19.9737 23.1936 23.1935 19.9738 23.1935 16.0204C23.1935 12.067 19.994 8.84718 16.0202 8.84718C12.0668 8.84718 8.84702 12.067 8.84702 16.0204ZM11 16C11 18.7557 13.2301 21 16 21C18.7557 21 21 18.7557 21 16C21 13.2443 18.7699 11 16 11C13.2443 11 11 13.2443 11 16Z",
              fill: "var(--icon-color)"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M21.8077 8.5415C21.8077 9.45853 22.5413 10.2125 23.4787 10.2125C24.4162 10.2125 25.1702 9.47891 25.1498 8.5415C25.1498 7.62447 24.4162 6.87046 23.4787 6.87046C22.5617 6.87046 21.8077 7.60409 21.8077 8.5415Z",
              fill: "var(--icon-color)"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M29.2664 25.1703C29.6128 24.2737 29.8574 23.2547 29.9185 21.7671L29.9198 21.7357C29.9799 20.2727 30 19.7838 30 16C30 12.1892 30 11.7205 29.9185 10.2329C29.837 8.74527 29.6128 7.72635 29.2664 6.8297C28.9199 5.89228 28.4309 5.1179 27.6565 4.34352C26.8821 3.56914 26.0873 3.10043 25.1703 2.73362C24.2736 2.38719 23.2547 2.14265 21.7671 2.08151L21.7357 2.08022C20.2727 2.02009 19.7839 2 16 2C12.2161 2 11.7273 2.02009 10.2643 2.08022L10.2329 2.08151C8.74527 2.16303 7.72634 2.38719 6.82969 2.73362C5.89228 3.08006 5.1179 3.56914 4.34352 4.34352C3.56914 5.1179 3.10044 5.91266 2.73363 6.8297C2.38719 7.72635 2.14265 8.74527 2.08151 10.2329L2.08023 10.264C2.02008 11.7273 2 12.2159 2 16C2 19.7841 2.02008 20.2727 2.08023 21.736L2.08151 21.7671C2.16303 23.2547 2.38719 24.2737 2.73363 25.1703C3.08006 26.1077 3.56914 26.8821 4.34352 27.6565C5.1179 28.4309 5.91266 28.8996 6.82969 29.2664C7.72634 29.6128 8.74527 29.8574 10.2329 29.9185L10.2643 29.9198C11.7273 29.9799 12.2161 30 16 30C19.7839 30 20.2727 29.9799 21.7357 29.9198L21.7671 29.9185C23.2547 29.837 24.2736 29.6128 25.1703 29.2664C26.1077 28.9199 26.8821 28.4309 27.6565 27.6565C28.4309 26.8821 28.8996 26.0873 29.2664 25.1703ZM26.9227 7.76711C26.6782 7.115 26.3521 6.6463 25.8834 6.15722C25.3943 5.66813 24.9256 5.36246 24.2735 5.11792C23.7844 4.93451 23.0508 4.71035 21.6855 4.62883L21.6384 4.62687C20.2082 4.56726 19.7294 4.54732 16.0403 4.54732C12.3114 4.54732 11.863 4.54732 10.3958 4.62883C9.03042 4.68997 8.2968 4.91413 7.80772 5.11792C7.15561 5.36246 6.6869 5.68851 6.19782 6.15722C5.70874 6.6463 5.40306 7.115 5.15852 7.76711C4.97511 8.2562 4.75095 8.98983 4.66943 10.3552L4.66747 10.4022C4.60786 11.8325 4.58792 12.3109 4.58792 16C4.58792 19.7293 4.58793 20.1776 4.66943 21.6448C4.73057 23.0102 4.95473 23.7438 5.15852 24.2329C5.40306 24.885 5.72912 25.3537 6.19782 25.8428C6.6869 26.3319 7.15561 26.6376 7.80772 26.8821C8.2968 27.0655 9.03042 27.2897 10.3958 27.3712L10.4428 27.3732C11.873 27.4328 12.3516 27.4527 16.0406 27.4527C19.7699 27.4527 20.2182 27.4527 21.6855 27.3712C23.0508 27.3101 23.7844 27.0859 24.2735 26.8821C24.9256 26.6376 25.3943 26.3115 25.8834 25.8428C26.3725 25.3537 26.6782 24.885 26.9227 24.2329C27.1061 23.7438 27.3303 23.0102 27.4118 21.6448L27.4138 21.5976C27.4734 20.1675 27.4933 19.6889 27.4933 16C27.4933 12.2708 27.4933 11.8224 27.4118 10.3552C27.3507 8.98983 27.1061 8.2562 26.9227 7.76711Z",
              fill: "var(--icon-color)"
            }
          )
        ]
      }
    );
  })
);
c.displayName = "IconInstagram";
export {
  c as IconInstagram
};
